var t = function t() {};

t.prototype.onAdd = function () {
  this.container = document.createElement("div"), this.container.className = "mapboxgl-ctrl";
  var t = document.createElement("img");
  t.src = "https://geolonia.github.io/logo/geolonia-symbol_1.png", t.style.width = "16px", t.style.height = "16px", t.style.display = "block", t.style.cursor = "pointer", t.alt = "Geolonia";
  var e = document.createElement("a");
  return e.href = "https://geolonia.com/", e.appendChild(t), e.title = "柔軟で自由度の高い位置情報ホスティング", this.container.appendChild(e), this.container;
}, t.prototype.onRemove = function () {
  this.container.parentNode.removeChild(this.container);
}, t.prototype.getDefaultPosition = function () {
  return "bottom-left";
}, module.exports = t;